import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Settings } from '../../../../core';
import { FileToLanguage } from '../../../../covance-file-upload/covance-file-upload.component';
import { FileFormArray } from '../../../../covance-file-upload/file-form-array';
import { maxLengthInBytes } from '../../../../shared/validators';
import { FilesWithDescription } from '../../models/e-query-create-data';

@Component({
    selector: 'e-query-attachments-uploader',
    template: require('./e-query-attachments-uploader.component.html'),
    styles: [require('./e-query-attachments-uploader.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EQueryAttachmentsUploaderComponent {
    @Input()
    public fileFormArray: FileFormArray;

    @Input()
    public editorForm: FormGroup;

    public fileEditorForm: FormGroup;
    public uploadedFiles: FilesWithDescription = new Map<File, string>();
    public uploadedFilesControls = new Map<File, FormControl>();
    public uploadedFileDescriptionControls = new Map<File, FormControl>();
    public selectedFiles: FileToLanguage;

    public readonly filesMaxCount: number;
    public readonly fileMaxSize: number;
    public readonly allowedExtensions: string[];
    public readonly maxAttachmentDescriptionBytes = 255;
    private readonly textMaxBytes = 2050;

    constructor(settings: Settings) {
        this.allowedExtensions = settings.eQueryAttachmentsExtensions;
        this.filesMaxCount = settings.eQueryMaxNumberOfAttachments;
        this.fileMaxSize = settings.eQueryMaxSizeOfAttachments;
    }

    public onFilesChanged(selectedFiles: FileToLanguage) {
        this.uploadedFiles.forEach((_, key) => {
            if (!selectedFiles.has(key)) {
                this.uploadedFiles.delete(key);
                this.uploadedFileDescriptionControls.delete(key);

                if (this.fileEditorForm) {
                    this.fileEditorForm.removeControl(key.name);
                }
            }
        });
        selectedFiles.forEach((_, key) => {
            if (!this.uploadedFiles.has(key)) {
                this.uploadedFiles.set(key, '');
                const newFormControl = new FormControl('', [Validators.required, maxLengthInBytes(this.textMaxBytes), this.noWhitespaceValidator]);
                this.uploadedFileDescriptionControls.set(key, newFormControl);
                newFormControl.updateValueAndValidity();
            }
        });
        this.selectedFiles = selectedFiles;
        this.uploadedFileDescriptionControls.forEach((controlValue, fileKey) => {
            if (this.fileEditorForm) {
                this.fileEditorForm.addControl(fileKey.name, controlValue);
            } else {
                this.fileEditorForm = new FormGroup({[fileKey.name]: controlValue});
                this.editorForm.addControl('fileEditorForm', this.fileEditorForm);
            }
        });
    }

    public getFilesWithDescriptions(): Map<File, string> {
        const filesToDescriptions = new Map<File, string>();
        this.uploadedFiles.forEach((_, key) => {
            filesToDescriptions.set(key, this.uploadedFileDescriptionControls.get(key).value);
        });
        return filesToDescriptions;
    }

    private noWhitespaceValidator(control: FormControl) {
        const isWhitespace = (control.value || '').trim().length === 0;
        const isValid = !isWhitespace;
        return isValid ? null : { 'whitespaces': true };
    }
}
